module.exports = __webpack_public_path__ + "components/weather-icon/static/nightheavysnow@2-87b6897dfede616fb84703de173db945.png";